import { useState } from 'react';
import { useMutation } from 'react-query';

// import { CustomEvents } from '../../../constants/analytics.constant';
import { useAuthDataContext } from '../../../context/auth/auth.provider';
import useLogEventInAnalytics from '../../../hooks/useLogAnalyticsEvent';
// import { login, nextLogin } from '../../../services/users/auth.service';
import { getContentForDialog } from '../Landing/constants';

export const useLoginForm = () => {
  const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);
  const { onLogin } = useAuthDataContext();
  const { logEvent } = useLogEventInAnalytics();

  const loginUser = useMutation(
    async (values: any) => {
      // return await login(values.identification_number, values.password);
      // console.log('loginUser', values)
      values.expiration_date = new Date().setHours(new Date().getHours() + 25);
      localStorage.setItem('user', JSON.stringify(values));
      return values;
    },
    {
      onSuccess: async (user: any) => {
        // console.log('success', user);
        onLogin(user);
        // onLogin(user.data);
        // await logEvent(CustomEvents.LOGIN, {
        //   method: 'identification_number',
        //   id: user.data.user.id
        // });
      },
      onError: async (error: any) => {
        // console.log('error', error)
        // setIsOpenDialog(true);
      },
    }
  );

  const closeDialog = () => {
    setIsOpenDialog(false);
  };

  const handleSubmit = async (values: any) => {
    // console.log('handleSubmit', values);
    loginUser.mutate(values);
  };

  return {
    handleSubmit,
    isLoading: loginUser.isLoading,
    error: loginUser.error,
    isError: loginUser.isError,
    isOpenDialog,
    closeDialog,
    dialog: getContentForDialog(
      // Se define esta condicion para manejar el error por usuario de otra compañia
      // ya que NO viene de backend sino que se define con otra estructura en
      // el servicio de "login"(en "auth.services").
      loginUser?.error instanceof EvalError
        ? loginUser?.error?.message
        : loginUser?.error?.response?.data?.error,
      closeDialog,
      logEvent
    ),
  };
};
